import angular from 'angular';
import uiRouter from 'angular-ui-router';
import racedayEditFormComponent from './racedayEditForm.component';

let racedayEditFormModule = angular.module('racedayEditForm', [
  uiRouter
])

.component('racedayEditForm', racedayEditFormComponent)

.name;

export default racedayEditFormModule;
